// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$LiveRoom from "../Config.bs.js";

function Make(Query) {
  var graphQLUrl = function (param) {
    return Config$LiveRoom.values.clientapiGraphqlUrl;
  };
  return {
          graphQLUrl: graphQLUrl,
          Query: Query
        };
}

export {
  Make ,
}
/* Config-LiveRoom Not a pure module */
